import { occupationEntityName } from '../../../../../../backend/config/shared';
import { PublicDataClient } from '@juvare/platform-sdk-js/PublicDataClient';
export function buildOccupationValueProvider(appName) {
    const publicData = new PublicDataClient(appName);
    return {
        type: `classifier.${occupationEntityName}`,
        label: 'Occupation',
        getValues: (params) => publicData
            .publicDataGetObject(`classifier-${occupationEntityName}`)
            .then((data) => {
            if (typeof params === 'string') {
                return data.filter((value) => value.groupId === params);
            }
            return data;
        }),
    };
}
